function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCloseM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 329 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154544",
    style: {
      fill: "none"
    },
    d: "M0 0h13v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 6.367 12.33.256A.155.155 0 0 0 12.211 0h-1.559a.318.318 0 0 0-.24.111L6.184 5.152 1.955.111A.312.312 0 0 0 1.715 0H.156a.155.155 0 0 0-.119.256l5.127 6.111-5.127 6.111a.155.155 0 0 0 .119.256h1.559a.318.318 0 0 0 .24-.111l4.229-5.041 4.228 5.041a.312.312 0 0 0 .24.111h1.559a.155.155 0 0 0 .119-.256z",
    transform: "translate(.316 .633)",
    style: {
      fill: "#7b7b7b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCloseM);
export default __webpack_public_path__ + "static/media/alertClose_m.034fe284e9304059e1747c5891fe8516.svg";
export { ForwardRef as ReactComponent };